import { isUuid } from '@/lib/validation';
import type { ServiceClient } from '../http/client';
import { ApiError } from '../http/errors';
export interface FirstMoveInDateCommand {
  command_id: string;
  expected_sale_revision: number;
  first_move_in_date: string;
  reason: string;
}
export interface FirstMoveInDateReceipt {
  command_id: string;
  room_id: string;
  revision: number;
  product: string;
  channel: string;
  first_move_in_date: string;
  provider_outcome: null;
}
const invalid = () =>
  new ApiError({
    kind: 'invalid-response',
    service: 'core',
    message: '첫 입주 가능일 변경 결과를 확인하지 못했습니다.',
  });
export async function changeRoomFirstMoveInDate(
  client: ServiceClient,
  roomId: string,
  command: FirstMoveInDateCommand,
): Promise<FirstMoveInDateReceipt> {
  const date = command.first_move_in_date;
  if (
    !isUuid(roomId) ||
    !isUuid(command.command_id) ||
    !Number.isSafeInteger(command.expected_sale_revision) ||
    command.expected_sale_revision < 0 ||
    typeof date !== 'string' ||
    !/^\d{4}-\d{2}-\d{2}$/.test(date) ||
    !Number.isFinite(Date.parse(`${date}T00:00:00Z`)) ||
    new Date(`${date}T00:00:00Z`).toISOString().slice(0, 10) !== date ||
    typeof command.reason !== 'string' ||
    !command.reason.trim() ||
    Array.from(command.reason).length > 500 ||
    Object.keys(command).length !== 4
  )
    throw invalid();
  const result = await client.patch<unknown>(`admin/rooms/${roomId}/first-move-in-date`, {
    json: command,
    expectedStatus: 200,
  });
  if (
    !result ||
    typeof result !== 'object' ||
    Object.keys(result).length !== 7 ||
    !('command_id' in result) ||
    !('room_id' in result) ||
    !('revision' in result) ||
    !('first_move_in_date' in result) ||
    !('product' in result) ||
    !('channel' in result) ||
    !('provider_outcome' in result) ||
    result.command_id !== command.command_id ||
    result.room_id !== roomId ||
    !Number.isSafeInteger(result.revision) ||
    result.revision !== command.expected_sale_revision + 1 ||
    result.first_move_in_date !== date ||
    result.product !== 'midterm' ||
    result.channel !== 'own_website' ||
    result.provider_outcome !== null
  )
    throw invalid();
  return result as FirstMoveInDateReceipt;
}
